import React, { Component } from 'react';
import DOMPurify from 'dompurify';
import moment from 'moment';
import FormsThemeFactory from '../formThemes/formThemeFactory';

class InputToRichTextComponent extends Component {
    constructor(props) {
        super(props);
        // this.addTag=this.addTag.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.wrapperRef = React.createRef();
        this.ref = React.createRef();
        this.setWrapperRef = this.setWrapperRef;
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.state = {
            value: this.props.value,
            min: this.props.min,
            max: this.props.max,
            html:<div></div>,
            textHtml:"<div></div>",
            index:1,
            n: 0,
            m:false,
            l:false,
            d:false,
            e:false,
            f:false,
            doubleSpace:false,
            backSlash: false,
            change:false,
            lastChar: "",
            colors:{
                m: 'orange',
                l: 'yellow',
                f: 'green',
                e: 'red',
                d:'#FFD700'

            }
        };
    }
    sanitizedData = (data) => ({
         __html: DOMPurify.sanitize(data)
      })

//    async addTag(innerText, value, c){
//     if(value===" " && this.state.backSlash){
//         if(this.state.m || this.state.d ||this.state.l||this.state.e||this.state.f){
//     for(let i=0; i<innerText.length; i++){
//         let n = innerText[i];
//         if(innerText[i]==="/" && innerText[i+1]===c){
//             let text= "";
//             let j = i+2;
//             let bool = true;
        
//             while(bool ){
//                 let bool1 = false;
//                 if(innerText[j]==="&"){
//                     bool1=true;
//                 }
//                 if(bool1 && (innerText[j+6]==="&"||innerText[j+6]===" ") ){
//                     bool=false;
//                     break;
//                 }
//                 text+=innerText[j];
//                 j++;
//             }
            
//             let preText = innerText.substring(0, i);
//             let newText = this.state.d? `<b n3z=${this.state.n} style=" color:#FFD700">${moment().format("MMM Do YY")}</b>` :`<b  n3z=${this.state.n} style=" color:${this.state.colors[c]}">${text} </b>`
            
//             let postText = innerText.substring(j);
//             innerText = preText+newText+postText;
//             break;
//         }
//     }
// }
    
//     let offset = await Cursor.getCurrentCursorPosition(this.ref.current)-3;
//    this.ref.current.innerHTML=innerText;
   
//     this.setCaret(offset);
//         let n = this.state.n+1;
//         this.setState({
//             backSlash:false,
//             m:false,
//             d:false,
//             e:false,
//             f:false,
//             l:false,
//             doubleSpace:false,
//             change:true,
//             n:n


//         })
//     }
//    }



    async handleChange(e) {

        let value = e.key;
        let innerText =DOMPurify.sanitize(this.ref.current.innerHTML);
        
//         if(value===" " &&this.state.lastChar===" " &&this.state.backSlash){
//             await this.setState({doubleSpace:true})
//         }
        
//  if(this.state.doubleSpace){
    
//     let c = 'm'
//     let obj ={
//         m: this.state.m,
//         l: this.state.l,
//         d: this.state.d,
//         e: this.state.e,
//         f: this.state.f,
//     }
//     for(const key in obj){
//         if(obj[key]){
//             c=key
//             break;
//         }
//     }
    
//            this.addTag(innerText, value,c )
//         }
        // if(value === "/"&& !this.state.backSlash){
        //     this.setState({backSlash:true});
        // }
        // if(this.state.backSlash && value === 'm' && this.state.lastChar==="/"){
        //     this.setState({m:true, d:false, e:false, f:false, l:false}) 
        // }
        // if(this.state.backSlash && value === 'd'&& this.state.lastChar==="/"){
        //     this.setState({m:false, d:true, e:false, f:false, l:false}) 
        // }
        // if(this.state.backSlash && value === 'e'&& this.state.lastChar==="/"){
        //     this.setState({m:false, d:false, e:true, f:false, l:false}) 
        // }
        // if(this.state.backSlash && value === 'f'&& this.state.lastChar==="/"){
        //     this.setState({m:false, d:false, e:false, f:true, l:false}) 
        // }
        // if(this.state.backSlash && value === 'l'&& this.state.lastChar==="/"){
        //     this.setState({m:false, d:false, e:false, f:false, l:true}) 
        // }
        await this.setState({save:innerText, lastChar: value});

        let save =DOMPurify.sanitize(this.ref.current.innerHTML);
        this.setState({theHtml:save})
        if(!this.props.updateOnClickOutside){
            this.props.handleHTMLChange(save);

        }
    }



    setCaret(offset) {
        let richText = this.ref.current;
        
        // insert code here that does stuff to the innerHTML, such as adding/removing <span> tags
        Cursor.setCurrentCursorPosition(offset, richText);
        richText.focus();
}
componentDidUpdate(){
    if(this.props.app?.state.updateInput){
        this.setState({textBox:false})
    }
}

    async componentDidMount() {
        
        let html;
        if(this.props.html!==undefined){
            html =  await DOMPurify.sanitize(this.props.html) 

        }
        else{
           html= await DOMPurify.sanitize(this.props.value) 
        }
        
        this.setState({textHtml:html})
       
        document.addEventListener('keyup', this.handleChange);
        document.addEventListener('mousedown', this.handleClickOutside);
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }
    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
            if (this.props.emitClickedOutside !== undefined)
            {
                this.props.emitClickedOutside(this.state);
            }
            if(this.props.updateOnClickOutside){
                this.props.handleHTMLChange(this.state.theHtml);
    
            }
        }
    }


    render() {
        let theme= undefined;
        if(this.props.theme){
            theme = FormsThemeFactory.getFormsThemeFactory()[this.props.theme]
        }
        let inputType = {
            normal: <div 
            ref={this.ref}
            
            dangerouslySetInnerHTML={{__html: this.state.textHtml}}
            contentEditable={true} className={this.props.class ? this.props.class : "form-control"}
            style={this.props.inputStyle? this.props.inputStyle: theme!==undefined? theme.richEditorStyle: {height:"200px"}}
            id="richText"
            onClick={this.props.onClick}></div>
           
        }




        return (
            <div ref={this.wrapperRef} style={this.props.wrapperStyle?{...this.props.wrapperStyle, position:"relative"}:theme!==undefined? {...theme.richEditorWrapperStyle, position:"relative"}:{width:"300px", position:"relative"}} className={this.props.wrapperClass}>
                {this.state.textBox &&(<div onClick={()=>{this.setState({textBox:false})}} style={{position:"absolute", right:"0", top:"0"}}>X</div>)}
                {this.props.label && (<label style={this.props.labelStyle? this.props.labelStyle:theme!==undefined?theme.richEditorLabelStyle:undefined} className={this.props.labelClass}>{this.props.label}</label>)}
                {!this.state.textBox?(
                <input type="text" value={this.state.value} style={this.props.inputStartStyle?this.props.inputStartStyle:theme!==undefined?theme.inputStart:undefined} onClick={()=>{this.setState({textBox:true})}} />):(
                <>{inputType[this.props.input]}</>)}
                <div className="componentErrorMessage" >{this.props.errorMessage}</div>
            </div>
        );
    }
}

// Credit to Liam (Stack Overflow)
// https://stackoverflow.com/a/41034697/3480193
class Cursor {
    static getCurrentCursorPosition(parentElement) {
        var selection = window.getSelection(),
            charCount = -1,
            node;
        
        if (selection.focusNode) {
            if (Cursor._isChildOf(selection.focusNode, parentElement)) {
                node = selection.focusNode; 
                charCount = selection.focusOffset;
                
                while (node) {
                    if (node === parentElement) {
                        break;
                    }

                    if (node.previousSibling) {
                        node = node.previousSibling;
                        charCount += node.textContent.length;
                    } else {
                        node = node.parentNode;
                        if (node === null) {
                            break;
                        }
                    }
                }
            }
        }
        
        return charCount;
    }
    
    static setCurrentCursorPosition(chars, element) {
        if (chars >= 0) {
            var selection = window.getSelection();
            
            let range = Cursor._createRange(element, { count: chars });

            if (range) {
                range.collapse(false);
                selection.removeAllRanges();
                selection.addRange(range);
            }
        }
    }
    
    static _createRange(node, chars, range) {
        if (!range) {
            range = document.createRange()
            range.selectNode(node);
            range.setStart(node, 0);
        }

        if (chars.count === 0) {
            range.setEnd(node, chars.count);
        } else if (node && chars.count >0) {
            if (node.nodeType === Node.TEXT_NODE) {
                if (node.textContent.length < chars.count) {
                    chars.count -= node.textContent.length;
                } else {
                    range.setEnd(node, chars.count);
                    chars.count = 0;
                }
            } else {
                for (var lp = 0; lp < node.childNodes.length; lp++) {
                    range = Cursor._createRange(node.childNodes[lp], chars, range);

                    if (chars.count === 0) {
                    break;
                    }
                }
            }
        } 

        return range;
    }
    
    static _isChildOf(node, parentElement) {
        while (node !== null) {
            if (node === parentElement) {
                return true;
            }
            node = node.parentNode;
        }

        return false;
    }
}

export default InputToRichTextComponent;